module.exports = __webpack_public_path__ + "static/media/HomepageLogo.baf8bb11.svg";